import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    // Garantir que o menu comece fechado
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden");
    }
  }

  toggle(event) {
    event.stopPropagation();

    // Fecha todos os outros nested dropdowns primeiro
    const allNestedDropdowns = document.querySelectorAll(
      "[data-nested-dropdown-target='menu']:not(.hidden)"
    );
    allNestedDropdowns.forEach((dropdown) => {
      if (dropdown !== this.menuTarget) {
        dropdown.classList.add("hidden");
      }
    });

    // Agora alterna o estado deste dropdown
    this.menuTarget.classList.toggle("hidden");
  }

  // Método explícito para fechar o menu
  close() {
    if (this.hasMenuTarget && !this.menuTarget.classList.contains("hidden")) {
      this.menuTarget.classList.add("hidden");
    }
  }
}
